import React from 'react';

export default function AudioPauseIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3333 5.3335H8V26.6668H13.3333V5.3335Z" fill="#FECB04" />
      <path d="M24 5.3335H18.6667V26.6668H24V5.3335Z" fill="#FECB04" />
    </svg>
  );
}
